import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import FormMixin from '@/amui/mixins/formMixin';
let AmBizUserSelector = class AmBizUserSelector extends Mixins(FormMixin) {
  constructor() {
    super(...arguments);
    this.visible = false;
    this.userList = [];
  }
  open() {
    this.visible = true;
  }
  confirm() {
    let _ref = this.$refs['amBizUserSelector'];
    if (_ref !== null && _ref !== void 0 && _ref.processing) {
      this.$message.warning('正在进行中，请稍后');
      return;
    }
    _ref === null || _ref === void 0 || _ref.getSelected().then(result => {
      console.log(result, '选择用户数据');
      this.$emit('input', result);
      this.$emit('confirm', result);
      this.visible = false;
    }).catch(e => {
      console.log(e);
    });
  }
};
AmBizUserSelector.componentName = 'AmBizUserSelector';
__decorate([Prop({
  default: 'button'
})], AmBizUserSelector.prototype, "selectType", void 0);
__decorate([Prop({
  default: () => {
    return window.lowcode.i18n.get('apaas_amui_userfield_label', '选择用户');
  }
})], AmBizUserSelector.prototype, "buttonText", void 0);
__decorate([Prop({
  default: 'primary'
})], AmBizUserSelector.prototype, "buttonType", void 0);
__decorate([Prop()], AmBizUserSelector.prototype, "tabs", void 0);
__decorate([Prop({
  default: 0
})], AmBizUserSelector.prototype, "limit", void 0);
__decorate([Prop()], AmBizUserSelector.prototype, "functionCode", void 0);
__decorate([Prop()], AmBizUserSelector.prototype, "dataPermissionCode", void 0);
__decorate([Prop({
  default: false
})], AmBizUserSelector.prototype, "enableGroupCorp", void 0);
__decorate([Prop()], AmBizUserSelector.prototype, "groupLimit", void 0);
__decorate([Prop({
  default: true
})], AmBizUserSelector.prototype, "isShowDeptment", void 0);
__decorate([Prop()], AmBizUserSelector.prototype, "targetOrgId", void 0);
__decorate([Prop({
  default: false
})], AmBizUserSelector.prototype, "disabledOrgSelect", void 0);
__decorate([Prop({
  default: false
})], AmBizUserSelector.prototype, "isOrgSelectAlone", void 0);
__decorate([Prop()], AmBizUserSelector.prototype, "projectGroupId", void 0);
__decorate([Prop()], AmBizUserSelector.prototype, "relationTips", void 0);
AmBizUserSelector = __decorate([Component({
  name: 'AmBizUserSelector'
})], AmBizUserSelector);
export default AmBizUserSelector;